import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import DashBoard from './components/DashBoard';
import NotFound from './components/NotFound';

function App() {
    return (
        <DndProvider backend={HTML5Backend}>
            <div className="App">
                <Router>
                    <Routes>
                        <Route path="/" element={<Navigate to="/home" replace />} />
                        <Route path="/*" element={<DashBoard />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Router>
            </div>
        </DndProvider>
    );
}

export default App;